// extracted by mini-css-extract-plugin
module.exports = {"shadow":"select_shadow__1kXsC","_title":"select__title__3j34X","shadow-05":"select_shadow-05__1_H3G","select":"select_select__24b4g"};